import React, { useState, useEffect } from 'react'
import { Col, Button, Alert } from 'react-bootstrap'
import { getParticipantDetails, isCustomerPhoneInRoom, isCustomerStillInMeeting, isTechnicianStillInMeeting } from '../../../utils'
import { getIdFromJobId, openNotificationWithIcon, startTimer, getCookie } from '../../../utils'
import { updateJob, getJobInformation, createSession } from '../../../api/meeting.api'
import { isMobile } from 'react-device-detect'
import notifySound from '../../../assets/sounds/notification.mp3'
import mixpanel from 'mixpanel-browser'
import { JobTags, JITSI_URL_GETGEEKER, DEVICE_STATUS_MESSAGES } from '../../../constants'
import * as JobCycleApi from '../../../api/jobCycle.api'
import { notification } from 'antd'
import { JITSI_BASE_URL_GETGEEKER, SCREEN_CONNECT_URL, JITSI_NEW_URL, IS_RECORDING_ENABLED } from '../../../constants'
import { MicPermissionModal } from './MicPermissionModal'
import { AllowRemoteAccessModal } from './AllowRemoteAccessModal'
import MicrophoneBlocked from '../../../assets/images/mic-blocked.png'
import { checkCameraPermissions, checkMediaPermission } from '../../../utils/microphoneStatus'
import { AutomaticCallConnectModal } from './AutomaticCallConnectModal'
import MeetingOnboarding from '../../MeetingOnboarding/MeetingOnboarding'
import { StartPaidTimerAlert } from '../../StartPaidTimerAlert/StartPaidTimerAlert'
import { useJitsiMeet } from '../../../context/jitsiMeetContext'
import SharingYourScreenModal from '../../Common/SharingYourScreenModal/SharingYourScreenModal'
import jobCreationBaseFunnelManager from '../../../funnels/jobCreationBaseFunnel'
// import { Modal } from 'antd'
// import { faHandPointRight, faCopy,faCheck } from '@fortawesome/free-solid-svg-icons';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useVolume } from '../../../context/VolumeProvider'

let api = null

const JitsiContainer = (props) => {
	const [showLoader, setShowLoader] = useState(true)
	const [showStopButton, setshowStopButton] = useState(false)
	const [jitsiMeetId, setJitsiMeetId] = useState(null)
	const [oneapi, setOneApi] = useState({})
	const [isMicPermissionGiven, setIsMicPermissionGiven] = useState(true)
	const [micPermission, setMicPermission] = useState('notSet')
	const [openAutomaticCallModal, setAutomaticCallModal] = useState(false)
	const [disconnectedUserType, setDisconnectedUserType] = useState('')
	const [connectionStatus, setConnectionStatus] = useState({
		internet: { verified: false, message: DEVICE_STATUS_MESSAGES.INTERNET_WEAK, type: 'connection' },
		speaker: { verified: false, message: DEVICE_STATUS_MESSAGES.SPEAKER_DISCONNECTED, type: 'speaker' },
		microphone: { verified: false, message: DEVICE_STATUS_MESSAGES.MICROPHONE_DISCONNECTED, type: 'microphone' },
	})
	const [openShareScreenModal, setOpenShareScreenModal] = useState(true)
	const { openBackDrop, setOpenBackDrop, showIssueButton, setShowIssueButton } = useJitsiMeet()
	let counter = 1
	let startRecordingInterval

	const [showRemoteAccessModalZoho, setShowRemoteAccessModalZoho] = useState(false)
	const [showRemoteZohoLinkTechSide, setShowRemoteZohoLinkTechSide] = useState(false)

	const [zohoUrl, setZohoUrl] = useState('')
	const [copySuccess, setCopySuccess] = useState('')
	const [meetingDetails, setMeetingDetails] = useState(null)
	const [showRestartRecording, setShowRestartRecording] = useState(false)
	const [isRecordingActive, setIsRecordingActive] = useState(false)
	const [jitsiFullyLoaded, setJitsiFullyLoaded] = useState(false)

	const { effectiveVolume } = useVolume()
	const audio = new Audio(notifySound)
	audio.volume = effectiveVolume

	// const [meetingStartedByCustomer,setMeetingStartedByCustomer] =  useState(false)

	useEffect(() => {
		let timer
		if (showRemoteZohoLinkTechSide) {
			// Show button after 5-6 seconds when modal is opened
			timer = setTimeout(() => {
				setShowIssueButton(true)
				localStorage.setItem(`showZohoLink-${props?.job?.id}`, props?.job?.id)
			}, 30000) // 30 seconds delay
		}

		return () => clearTimeout(timer) // Clean up timer on modal close
	}, [showRemoteAccessModalZoho, props?.job?.id])

	useEffect(() => {
		if (!showLoader) {
			return () => { }
		}
		if (
			props.internetConnectionStatus[props.userType] &&
			Number(props.internetConnectionStatus[props.userType]) > 10 &&
			!connectionStatus.internet.verified
		) {
			setConnectionStatus((prev) => ({
				...prev,
				internet: {
					...prev.internet,
					verified: true,
					message: DEVICE_STATUS_MESSAGES.INTERNET_STRONG,
				},
			}))
		}
		if (micPermission === 'permission-given' && !connectionStatus.microphone.verified) {
			setConnectionStatus((prev) => ({
				...prev,
				microphone: {
					...prev.microphone,
					verified: true,
					message: DEVICE_STATUS_MESSAGES.MICROPHONE_CONNECTED,
				},
				speaker: {
					...prev.speaker,
					verified: true,
					message: DEVICE_STATUS_MESSAGES.SPEAKER_CONNECTED,
				},
			}))
		}
	}, [props.internetConnectionStatus, micPermission])

	// useEffect(() => {
	// 	if (props.meetingStartedByCustomer && props.userType == 'technician') {
	// openNotificationWithIcon('success', 'Meeting is resumed, billing starts now.');
	// 	}
	// }, [props.meetingStartedByCustomer])

	// props.socket.on('meeting-started-update-tech', async (data) => {
	// 	if(props.job.id === data.jobId){
	// 		setHasMeetingStarted(true)
	// 		setOpenBackDrop(false)
	// 		setMeetingStartedByCustomer(true)
	// 	}
	// })

	const [jitsiFakeLoader, setJitsiFakeLoader] = useState({
		firstLoading: 'loading',
		secondLoading: 'toLoad',
		thirdLoading: 'toLoad',
		fourthLoading: 'toLoad',
		fifthLoading: 'toLoad',
		sixthLoading: 'toLoad',
	})

	// These states are used to track conference joined if so then don't run fakeLoaderMessages function
	const [jitsiCountdownTimer, setJitsiCountDownTimer] = useState({ timer: 10, occurrence: 0, destroyCountDown: false })
	const [conferenceJoined, setConferenceJoined] = useState(false)

	let notificationMsgShow = false

	/**
	 *this function check whether both customer and tech joined from pc once "
	 * @author : Sahil Sharma
	 */
	const checkDesktopAvailability = (partispantsArr) => {
		try {
			const techName = props.job.technician.user.firstName.trim() + ' ' + props.job.technician.user.lastName.trim() + ' ' + '(t)'
			const custName = props.job.customer.user.firstName.trim() + ' ' + props.job.customer.user.lastName.trim() + ' ' + '(c)'
			let techJoined = partispantsArr.find((element) => element.displayName == techName)
			let custJoined = partispantsArr.find((element) => element.displayName == custName)
			console.log('checkDesktopAvailability :::::: 0', { techName, custName, techJoined, custJoined })

			if (techJoined !== undefined && custJoined !== undefined) {
				mixpanel.identify(props.user.email)
				mixpanel.track(`${props.userType} - joined from desktop`, { JobId: props.job.id, UserId: props?.user?.id })
				console.log('checkDesktopAvailability :::::: 1')
				return true
			} else {
				console.log('User not joined in Jitsi checkDesktopAvailability')
				return false
			}
		} catch (err) {
			console.log('Error in checkDesktopAvailability::::', err)
			return false
		}
	}

	/**
	 *this function check whether both customer or tech joined from phone call once "
	 * @author : Mritunjay Chaurasia
	 */
	const checkPhoneAvailability = (partispantsArr) => {
		try {
			const techPhoneNumber = props.job.technician.profile.confirmId.phoneNumber
			const custPhoneNumber = props.job.customer.phoneNumber
			// let techJoined = partispantsArr.find((element) => element.displayName === techPhoneNumber) !== undefined
			let custJoined = partispantsArr.find((element) => element.displayName === custPhoneNumber) !== undefined
			console.log('checkPhoneAvailability>>>>>>>>>>>>>>>', custJoined)
			if (custJoined) {
				props.setPhoneStatusAvailability(true)
				mixpanel.identify(props.user.email)
				mixpanel.track(`${props.userType} - joined from Phone`, { JobId: props.job.id, UserId: props.user.id })
				return true
			} else {
				console.log('User not joined in Jitsi checkPhoneAvailability')
				props.setPhoneStatusAvailability(false)
				return false
			}
		} catch (err) {
			console.log('Error in checkPhoneAvailability::::', err)
			return false
		}
	}

	// Function to generate a random 5-digit number
	// const generateRandomCode = () => {
	// 	return Math.floor(10000 + Math.random() * 90000);
	// };

	useEffect(() => {
		props.socket.on('fileupload-notification-frontend', async (data) => {
			console.log('fileupload-notification-frontend', data)
			if (!data.deleteFile) {
				if (data.userType == 'customer') {
					if (props.userType == 'technician') {
						audio.play()
						console.log('fileupload-notification-frontend 1')

						openNotificationWithIcon(
							'info',
							'Info',
							`📁 ${data.job.customer.user.firstName.replace(/^\w/, (c) =>
								c.toUpperCase(),
							)} sent a file. You can view the uploaded files by clicking on the "Upload File" button.`,
						)
					}
				}

				if (data.userType === 'technician') {
					if (props.userType === 'customer') {
						audio.play()
						openNotificationWithIcon(
							'info',
							'Info',
							`📁 ${data.job.technician.user.firstName.replace(/^\w/, (c) =>
								c.toUpperCase(),
							)} sent a file. You can view the uploaded files by clicking on the "Upload File" button.`,
						)
					}
				}
			}
		})
	}, [props.socket])

	useEffect(() => {
		const handleRemoteScreenConnect = async (data) => {
			console.log('Testing::enableRemoteScreenConnect:Customer-Technician', data)

			if (data && data.userClicks === props.user.userType) {
				// const randomCode = generateRandomCode();
				// const meetingInfo = {
				// 	sessionType: 'Support',
				// 	name: `Geeker_${props?.job?.id}`,
				// 	isPublic: false,
				// 	code: randomCode,
				// };
				// console.log('Testing:: meetingInfo', meetingInfo);
				try {
					// const response = await createSession(meetingInfo, props?.user?.id);
					// console.log('response from server', response);
					// setMeetingDetails(response.meetingDetails);

					// if (response && response.success) {
					// const { baseUrl, meetingDetails } = response;
					// props.setIsRemoteLoading(false);
					// console.log("zoho-session user side", props?.user?.userType, props?.user);

					// let url = baseUrl;
					// setZohoUrl(url);

					// Notify both the customer and technician
					// props.socket.emit('screenConnect-session', {
					// 	// url,
					// 	// meetingDetails,
					// 	userType: 'customer',
					// 	jobId: props.job.id
					// });
					props.socket.emit('screenConnect-session', {
						// url,
						// meetingDetails,
						userType: 'technician',
						jobId: props.job.id,
					})

					// } else {
					// 	props.setIsRemoteLoading(false);
					// 	console.error('Failed to create session:', response);
					// 	openNotificationWithIcon('error', "Error", response.message || 'Something went wrong');
					// }
				} catch (error) {
					props.setIsRemoteLoading(false)
					console.error('Error creating session:', error.message)
					openNotificationWithIcon('error', 'Error', error.response?.data?.message || 'Failed to create session: Internal Server Error')
				}
			}
		}

		// Attach the event listener
		props.socket.on('enableRemoteScreenConnect:Customer-Technician', handleRemoteScreenConnect)

		// Cleanup function to remove the event listener
		return () => {
			props.socket.off('enableRemoteScreenConnect:Customer-Technician', handleRemoteScreenConnect)
		}
	}, [props.socket, props.user])

	useEffect(() => {
		// props.socket.on('screen-connect-session-customer', (socketData) => {
		// 	// console.log('screen-connect-session-customer', socketData);
		// 	if (socketData) {
		// 		// props.setIsRemoteLoading(false);
		// 		// setMeetingDetails(socketData.meetingDetails);
		// 		// console.log("zoho-session customer side", props?.user?.userType, props?.user);
		// 		// setZohoUrl(socketData.url);
		// 		// openModal();
		// 	}
		// });

		props.socket.on('screen-connect-session-technician', (socketData) => {
			console.log('screen-connect-session-technician', socketData)
			if (socketData && props.userType == socketData.userType) {
				// props.setIsRemoteLoading(false);
				// setMeetingDetails(socketData.meetingDetails);
				// // console.log("zoho-session technician side", props?.user?.userType, props?.user);
				// setZohoUrl(socketData.url);
				// openModal();
				window.open(SCREEN_CONNECT_URL, '_blank')
			}
		})
	}, [props.socket])

	// const handleCopyClick = () => {
	// 	if (meetingDetails) {
	// 	navigator.clipboard.writeText(meetingDetails.Code).then(() => {
	// 	  setCopySuccess('Copied!');
	// 	  openNotificationWithIcon('success', 'Success','Code copied');
	// 	  setTimeout(() => setCopySuccess(false), 2000);
	// 	}, (err) => {
	// 	  setCopySuccess('Failed to copy!');
	// 	  openNotificationWithIcon('error', 'Error','Failed copied');

	// 	});
	// }
	//   };

	/**
	 * @description  : This useEffect will show toast to technician that customer have mic problem.
	 * @author : Jagroop
	 */
	useEffect(() => {
		if (props.userType == 'technician' && props.job.callStartType === 'ComputerAudio' && !props.phoneStatusAvailability) {
			props.socket.on('customer-mic-issue:send-back-to-tech', (data) => {
				if (data?.micError) {
					openNotificationWithIcon('error', "Can't Access Customer's Microphone", 'Please help customer regarding microphone permissions')
				}
			})
		}
	}, [])

	useEffect(() => {
		checkMicrophoneStatus()
		fakeLoaderMessages()
		if (isMobile) {
			checkCameraStatus()
		}
	}, [])

	const fakeLoaderMessages = () => {
		setTimeout(() => {
			setJitsiFakeLoader((prev) => ({ ...prev, firstLoading: 'loaded', secondLoading: 'loading' }))
			setTimeout(() => {
				setJitsiFakeLoader((prev) => ({ ...prev, secondLoading: 'loaded', thirdLoading: 'loading' }))
				setTimeout(() => {
					setJitsiFakeLoader((prev) => ({ ...prev, thirdLoading: 'loaded', fourthLoading: 'loading' }))
					setTimeout(() => {
						setJitsiFakeLoader((prev) => ({ ...prev, fourthLoading: 'loaded', fifthLoading: 'loading' }))
						setTimeout(() => {
							setJitsiFakeLoader((prev) => ({ ...prev, fifthLoading: 'loaded', sixthLoading: 'loading' }))
							setJitsiCountDownTimer({ ...jitsiCountdownTimer, timer: 10, occurrence: jitsiCountdownTimer.occurrence + 1 })
						}, 3000)
					}, 3000)
				}, 3000)
			}, 3000)
		}, 3000)
	}

	useEffect(() => {
		const loadingState = jitsiFakeLoader.sixthLoading === 'loading'
		const occurrenceOfMsgs = jitsiCountdownTimer.occurrence <= 2
		const micConnected = micPermission == 'permission-given'
		const participantJoined = conferenceJoined
		console.log('jitsiCountdownTimer participantJoined', conferenceJoined, jitsiCountdownTimer)
		if (participantJoined) {
			return () => { }
		}
		if (loadingState && occurrenceOfMsgs && !participantJoined && micConnected) {
			if (jitsiCountdownTimer && jitsiCountdownTimer.timer >= 1) {
				let intervalId = setInterval(() => {
					setJitsiCountDownTimer({ ...jitsiCountdownTimer, timer: jitsiCountdownTimer.timer - 1 })
				}, 1000)

				return () => clearInterval(intervalId)
			}
			if (jitsiCountdownTimer && jitsiCountdownTimer.timer < 1) {
				initialiseJitsi(false)
				setJitsiFakeLoader({
					firstLoading: 'loading',
					secondLoading: 'toLoad',
					thirdLoading: 'toLoad',
					fourthLoading: 'toLoad',
					fifthLoading: 'toLoad',
					sixthLoading: 'toLoad',
				})
				fakeLoaderMessages()
			}
		}
		if (jitsiCountdownTimer.occurrence >= 2 && !participantJoined) {
			retryJitsi()
		}
	}, [jitsiCountdownTimer, micPermission])

	const checkMicrophoneStatus = async () => {
		const permissionState = await checkMediaPermission()
		console.log('check the microphoneStatus', permissionState)
		if (permissionState) {
			setMicPermission(permissionState)
		}
	}

	const checkCameraStatus = async () => {
		const permissionState = await checkCameraPermissions()
		console.log('check camera permission', permissionState)
		if (permissionState != 'permission-given') {
			openNotificationWithIcon('warning', permissionState)
		}
	}

	useEffect(() => {
		; (async () => {
			/**
			 * Set jitsiMeetID variable when Job and User data found
			 * @author : Karan
			 */
			if (props.job && props.job.id && props.user) {
				const jobId = await getIdFromJobId(props.job.id)
				// console.log('JitsiContainer:::setJitsiMeetId', jobId)
				setJitsiMeetId(jobId)
			}
		})()
	}, [props.job, props.user])

	useEffect(() => {
		/**
		 * Call initialise jitsi function when jitsiMeetId set
		 * @author : Karan
		 */
		if (jitsiMeetId) {
			if (props.job.callStartType === 'ComputerAudio') {
				console.log('JitsiContainer:::initialiseJitsi:::type 1')
				initialiseJitsi(false)
			} else {
				if (props.user && props.userType === 'customer') {
					console.log('JitsiContainer:::initialiseJitsi:::type 2')
					initialiseJitsi(true)
				} else {
					// console.log('JitsiContainer:::initialiseJitsi:::type 3')
					// props.job.technician_started_call = true

					if (props?.user && props.userType == 'technician') {
						console.log('JitsiContainer:::initialiseJitsi:::type 3')
						let start_call_technician = props.job.technician_started_call ? props.job.technician_started_call : false
						initialiseJitsi(start_call_technician)
					} else {
						console.log('JitsiContainer:::initialiseJitsi:::type 4')
						initialiseJitsi(false) //Enable computer audio for customer
					}
				}
			}
		}

		return () => {
			clearInterval(startRecordingInterval)
		}
	}, [jitsiMeetId])

	// Setup recording status listener with proper cleanup
	useEffect(() => {
		if (!api) return

		const handleRecordingStatusChanged = (event) => {
			console.log('🎥 Recording status changed:', event)
			
			// Always ignore duplicate request errors
			if (event.error === 'unexpected-request') {
				console.log('⚠️ Ignoring unexpected-request error')
				return
			}

			if (event.on === true) {
				console.log('✅ Recording is ACTIVE')
				setIsRecordingActive(true)
				setShowRestartRecording(false)
			} else if (event.on === false) {
				console.log('🔴 Recording STOPPED')
				setIsRecordingActive(false)
				
				// Only show banner if Jitsi is fully loaded and some time has passed
				if (jitsiFullyLoaded) {
					setShowRestartRecording(true)
				}
			}
		}

		api.addListener('recordingStatusChanged', handleRecordingStatusChanged)

		// Mark Jitsi as fully loaded after a delay to prevent initial flash
		const loadedTimer = setTimeout(() => {
			setJitsiFullyLoaded(true)
			console.log('🟢 Jitsi marked as fully loaded - recording banner can now show')
		}, 30000) // 30 seconds delay to allow recording to start

		// Cleanup: Remove listener when component unmounts or api changes
		return () => {
			api.removeListener('recordingStatusChanged', handleRecordingStatusChanged)
			clearTimeout(loadedTimer)
		}
	}, [api, jitsiFullyLoaded])

	const getScriptUrl = () => {
		const baseUrl = props.job.jitsi_base_url || JITSI_BASE_URL_GETGEEKER
		return `https://${baseUrl}external_api.js`
	}

	/**
	 * Load scripts to initialise jitsi
	 * @params = ''
	 * @response : Will load JS scripts
	 * @author : Karan
	 */
	const loadJitsiScript = async () => {
		console.log('JitsiContainer:::loadJitsiScript')

		const appendScript = (url) => {
			return new Promise((resolve) => {
				const script = document.createElement('script')
				script.src = url
				script.async = true
				script.onload = () => resolve(true)
				script.onerror = () => {
					console.error('JitsiContainer::: Failed to load script from', url)
					resolve(false)
				}
				document.body.appendChild(script)
			})
		}

		const scriptURL = getScriptUrl()
		let loaded = await appendScript(scriptURL)

		// If the primary script fails and it wasn't already the New Jitsi URL, try the New Jitsi as fallback
		if (!loaded && scriptURL.indexOf(JITSI_NEW_URL) === -1) {
			console.warn('Primary Jitsi failed, trying New Jitsi fallback...')
			loaded = await appendScript(`https://${JITSI_NEW_URL}external_api.js`)
			if (loaded) {
				openNotificationWithIcon('warning', 'Connection Fallback', 'The selected Jitsi server was unreachable. Switched to New Jitsi automatically.')
			}
		}

		// Load supporting scripts
		appendScript('https://code.jquery.com/jquery-3.5.1.min.js')
		appendScript('https://meet.jit.si/libs/lib-jitsi-meet.min.js')

		return loaded
	}

	/**
	 * @description : This function will provide configurations to Jitsi.
	 * @author : Jagroop
	 */
	const chooseConfigObjects = (computerAudioEnabled, startSilentMeeting) => {
		// Interface Config Overwrite
		const interFaceConfigOverwriteObject = {
			SHOW_PROMOTIONAL_CLOSE_PAGE: false,
			DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
		}
		// Config Overwrite
		const startVideoMuted = isMobile ? false : true
		let toolbarButtons = ['microphone', 'fullscreen', 'fodeviceselection', 'profile', 'desktop']
		if (isMobile) {
			toolbarButtons = [...toolbarButtons, "camera", "toggle-camera"]
		}
		const configOverWriteObject = {
			startScreenSharing: false,
			startWithAudioMuted: computerAudioEnabled,
			startWithVideoMuted: startVideoMuted,
			startSilent: startSilentMeeting,
			notifications: [
				// 'recording.busy', // shown when recording service is busy
				// 'recording.failedToStart', // shown when recording fails to start
				// 'recording.unavailableTitle', // shown when recording service is not reachable
				'dialog.serviceUnavailable', // shown when server is not reachable
				'dialog.sessTerminated', // shown when there is a failed conference session
				'connection.CONNFAIL', // shown when the connection fails,
				'dialog.micNotSendingData', // shown when user's mic is not sending any audio
				'toolbar.noAudioSignalTitle', // shown when a broken mic is detected
				'toolbar.noisyAudioInputTitle', // shown when noise is detected for the current microphone],
				'notify.startSilentTitle', // shown when user joined with no audio
			],
			toolbarButtons: toolbarButtons,
			disableDeepLinking: true,
			cameraFacingMode: 'user'
		}

		return { interFaceConfigOverwriteObject, configOverWriteObject }
	}



	// const chooseConfigObjects = (computerAudioEnabled, startSilentMeeting) => {
	// 	const interFaceConfigOverwriteObject = {
	// 		SHOW_PROMOTIONAL_CLOSE_PAGE: false,
	// 		DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
	// 	}

	// 	const startVideoMuted = isMobile ? false : true

	// 	const configOverWriteObject = {
	// 		startScreenSharing: false,
	// 		startWithAudioMuted: computerAudioEnabled,
	// 		startWithVideoMuted: startVideoMuted,
	// 		startSilent: startSilentMeeting,
	// 		disableDeepLinking: true,
	// 		cameraFacingMode: 'user',

	// 		notifications: [
	// 			'dialog.serviceUnavailable',
	// 			'dialog.sessTerminated',
	// 			'connection.CONNFAIL',
	// 			'dialog.micNotSendingData',
	// 			'toolbar.noAudioSignalTitle',
	// 			'toolbar.noisyAudioInputTitle',
	// 			'notify.startSilentTitle',
	// 		],
	// 	}

	// 	return { interFaceConfigOverwriteObject, configOverWriteObject }
	// }

	const selectMeetingMedium = () => {
		return props.job.jitsi_base_url || JITSI_BASE_URL_GETGEEKER
	}

	/**
	 * Initialise jitsi to start the meeting
	 * @params = computerAudioEnabled=True/False
	 * @response : Will initialise jitsi
	 * @author : Karan
	 */
	const initialiseJitsi = async (computerAudioEnabled) => {
		console.log('JitsiContainer:::initialiseJitsi')
		let displayNametype
		try {
			let startSilentMeeting = computerAudioEnabled ? true : false
			let customerCalledHimself = false
			let callDone = true
			// const wantToUseComputerAudio =
			// 	window.localStorage.getItem('usingComputerAudio') && window.localStorage.getItem('usingComputerAudio') == 'true' ? true : false

			if (!window.JitsiMeetExternalAPI) {
				const loaded = await loadJitsiScript()
				if (!loaded) {
					openNotificationWithIcon('error', 'Connection Error', `Failed to load Jitsi from ${props.job.jitsi_base_url}. The server may be unreachable.`)
					setShowLoader(false)
					return
				}
				console.log('JitsiContainer:::loadJitsiScriptLoaded Successfully')
			} else {
				console.log('JitsiContainer:::already have jitsi.')
			}

			console.log('JitsiContainer:::Ready to start the jitsi...')

			if (window.localStorage.getItem('customerCallingHimSelf') !== null && window.localStorage.getItem('customerCallingHimSelf') === 'true') {
				startSilentMeeting = true
				customerCalledHimself = true
				// setAudioIcon(true)
			}
			if (props.user && props.userType === 'customer' && props.job.technician_started_call) {
				startSilentMeeting = true
				customerCalledHimself = false
				computerAudioEnabled = false
			}
			if (props.userType == 'technician' && props.job.technician_started_call) {
				startSilentMeeting = false
				computerAudioEnabled = false
				customerCalledHimself = true
			}

			// This condition will only works when  technicina want to unmute customer
			const unMuteCusomter = window.sessionStorage.getItem('unMuteCusomter')
			if (props.user && props.userType === 'customer' && unMuteCusomter && unMuteCusomter == 'yes') {
				startSilentMeeting = false
				customerCalledHimself = false
				computerAudioEnabled = false
			}

			// When Customer press button Computer Audio then this will set on LocalStorage .So this local storage is used to start/restart meeting with Enabled microphone if available
			const usingComputerAudio =
				window.localStorage.getItem('usingComputerAudio') && window.localStorage.getItem('usingComputerAudio') == 'true' ? true : false
			const customerCallingHimSelf =
				window.localStorage.getItem('customerCallingHimSelf') !== null && window.localStorage.getItem('customerCallingHimSelf') === 'true'
					? true
					: false

			if (props.user && props.userType === 'customer' && usingComputerAudio && !customerCallingHimSelf) {
				startSilentMeeting = false
				customerCalledHimself = false
				computerAudioEnabled = false
			}
			if (props.userType == 'technician') {
				displayNametype = '(t)'
			} else {
				displayNametype = '(c)'
			}
			// console.log('JitsiContainer:::InvokingJitsiMeetExternalAPI')
			const configObjects = chooseConfigObjects(computerAudioEnabled, startSilentMeeting)
			let interFaceConfigOverwriteObject = configObjects.interFaceConfigOverwriteObject
			let configOverWriteObject = configObjects.configOverWriteObject
			const MEETING_MEDIUM = selectMeetingMedium()
			const PARENT_NODE = props.jitsiContainerId
			// console.log('Verification log that will check correct data is send to the Jitsi API', { configObjects, MEETING_MEDIUM, PARENT_NODE })
			// Get Jitsi token from localStorage (populated from cookie)
			const jitsiToken = localStorage.getItem('jitsi_token') || ''
			console.log('JitsiContainer::: Using Jitsi token:', jitsiToken ? 'Token found' : 'No token found')

			api = new window.JitsiMeetExternalAPI(MEETING_MEDIUM, {
				interfaceConfigOverwrite: interFaceConfigOverwriteObject,
				configOverwrite: configOverWriteObject,
				parentNode: document.getElementById(PARENT_NODE),
				roomName: jitsiMeetId,
				jwt: jitsiToken,
				displayName: 'Geeker Meeting',
				userInfo: {
					displayName: props.user?.firstName.trim() + ' ' + props.user?.lastName.trim() + ' ' + displayNametype,
					email: props?.user?.email,
					id: 1,
					userId: props?.user?.id,
				},
			})

			// console.log('JitsiContainer::: AfterInvokingJitsiMeetExternalAPI setJitsiApi:::', api)
			setOneApi(api)
			props.setJitsiApi(api)
			// This code is commented by Jagroop as it with this customer call started with ComputerAudio and not with Phone
			// if (props.user && props.userType === 'technician' && props.job.technician_started_call && props.job.technician_started_call == true) {
			// 	updateJob(props.job.id, { dataToUpdate: { callStartType: 'ComputerAudio' }, cuId:props.user.id })
			// }
			if (props.user && props.userType === 'customer') {
				updateJob(props.job.id, {
					dataToUpdate: { technician_started_call: false },
					cuId: props?.user?.id,
				})
			}

			if (props.job.callStartType === 'ComputerAudio' && !props.phoneStatusAvailability) {
				api.on('micError', (type, message) => {
					console.log('micError>>>>>>>>>>>>>>>>>', type, message)
					//mixpanel code
					mixpanel.identify(props.user.email)
					mixpanel.track(`${props.userType} - micError`, { JobId: props.job.id, message: message })
					//mixpanel code
					// This socket helps to send popup to technician that my(customer) mic is not working
					if (props.userType === 'customer') {
						const data = {
							JobId: props.job.id,
							micError: true,
						}
						props.socket.emit('customer-mic-issue', data)
					}
					if (micPermission != 'permission-given') {
						const notificationInfo = {
							key: 'MicPermissionIssue',
							duration: 4,
							message: 'Microphone not available',
							description: (
								<>
									Geeker requires access to your microphone.Click to the Microphone blocked icon{' '}
									<span>
										<img src={MicrophoneBlocked} className="img-fluid microphone-image-style" />
									</span>{' '}
									in your browser's address bar.
								</>
							),
						}
						notification.warn(notificationInfo)
					} else {
						openNotificationWithIcon(
							'info',
							'Info',
							'Check your system settings to make sure that a microphone is available. If not, plug one in. You might then need to restart your browser.',
						)
					}
				})
			}
			api.on('browserSupport', (data) => {
				console.log('JitsiContainer::: IsCurrentBrowserSupported ::: ', data.supported)
			})
			api.on('log', (logLevel, args) => {
				console.log('JitsiContainer::: logLevel :::: ', logLevel)
				console.log('JitsiContainer::: args ::: ', args)
			})
			api.on('toolbarButtonClicked', (key, preventExecution) => {
				console.log('JitsiContainer::: toolbarButtonClicked ::::::: ')
				api.executeCommand('toggleShareScreen')
				mixpanel.identify(props.user.email)
				mixpanel.track(`${props.userType} - toolbarButtonClicked `, { JobId: props.job.id, customerClickedOn: key })
			})
			api.on('errorOccurred', (details, message, name, type, isFatal) => {
				console.log('JitsiContainer::: error occured in jitsi api :::::: please check', {
					details: details,
					message: message,
					name: name,
					type: type,
					isFatal: isFatal,
				})
			})
			api.on('videoConferenceLeft', (info) => {
				console.log('JitsiContainer::: videoConferenceLeft :', info)
				//mixpanel code
				mixpanel.identify(props.user.email)
				mixpanel.track(`${props.userType} - videoconferenceleft`, { JobId: props.job.id })
				//mixpanel code
				stopShareScreen()
			})

			if (computerAudioEnabled) {
				api.setAudioOutputDevice(null, null)
			}

			api.on('videoConferenceJoined', (info) => {
				console.log('JitsiContainer:::videoConferenceJoined :', info)
				setConferenceJoined(true)
				if (props?.job?.meeting_start_time) {
					// console.log('JitsiContainer:::videoConferenceJoined  1:', info)
					notification.destroy()
					notification.success({ key: 'videoConferenceJoined', duration: 4, message: "You've been reconnected! Enjoy your meeting" })
					props.socket.emit('reconnection-alert', { JobId: props.job.id, reconnected: true, userType: props.userType })
					const reconnected = sessionStorage.getItem('reconnected') === 'true'

					if (reconnected) {
						console.log('JitsiContainer:::videoConferenceJoined  1:', info)
						notification.destroy()
						notification.success({ key: 'videoConferenceJoined', duration: 4, message: "You've been reconnected! Enjoy your meeting" })
						props.socket.emit('reconnection-alert', { JobId: props.job.id, reconnected: true, userType: props.userType })
					} else {
						sessionStorage.setItem('reconnected', 'true')
					}
				}
				if (!props?.job?.meeting_start_time) {
					checkParticipantInfo(15000)
				}
				//socket.emit("DisableLoader")
				//mixpanel code
				mixpanel.identify(props.user.email)
				mixpanel.track(`${props.userType}- Jitsi session started'`, { JobId: props.job.id })
				setShowLoader(false)
				//mixpanel code
			})

			api.on('participantLeft', async (info) => {
				if (props?.job?.meeting_start_time && !props.jitsiSessionEnd) {
					console.log('JitsiContainer:::participantLeft :', info)
					checkParticipantInfo(45000)

					let joinedParticipentArr = []
					try {
						joinedParticipentArr = await api.getRoomsInfo()
					} catch (error) {
						joinedParticipentArr = api.getParticipantsInfo()
					}
					if (joinedParticipentArr.length <= 0) {
						joinedParticipentArr = api.getParticipantsInfo()
						console.log('JitsiContainer::: participantInfo inside participantLeft condition', joinedParticipentArr)
					}
					checkPhoneAvailability(joinedParticipentArr)
				}
				//socket.emit("DisableLoader")
				//mixpanel code
				mixpanel.identify(props.user.email)
				mixpanel.track(`${props.userType}- Jitsi participant left'`, { JobId: props.job.id })
				setShowLoader(false)
				//mixpanel code
			})

			// Handle when current user is kicked out
			api.on('participantKickedOut', async (info) => {
				console.log('JitsiContainer::: participantKickedOut :', info)

				const redirectToDashboard = () => {
					setTimeout(() => {
						const dashboardUrl =
							props.userType === 'technician'
								? `${process.env.REACT_APP_MAIN_APP_URL}/dashboard/technician`
								: `${process.env.REACT_APP_MAIN_APP_URL}/dashboard`
						window.location.href = dashboardUrl
					}, 1000)
				}

				// Jitsi fires this for all clients when anyone is kicked
				if (!info?.kicked?.local) {
					return
				}

				if (props.userType === 'technician') {
					redirectToDashboard()
					return
				}

				// Customer browser leg removed — redirect only if phone leg is also gone
				let participants = []
				try {
					participants = await getParticipantDetails(api, props.userType)
				} catch (e) {
					participants = api.getParticipantsInfo() || []
				}

				if (isCustomerPhoneInRoom(participants, props.job)) {
					console.log('JitsiContainer::: browser leg kicked but phone still in room — staying')
					return
				}

				redirectToDashboard()
			})

			api.on('screenSharingStatusChanged', (screen_data) => {
				console.log('JitsiContainer:::screenSharingStatusChanged :', screen_data)
				props.setIsScreenShared(screen_data && screen_data.on ? screen_data.on : false)
				if (screen_data['on'] === true) {
					setshowStopButton(true)
				} else {
					setshowStopButton(false)
				}

				mixpanel.identify(props.user.email)
				mixpanel.track(`${props.userType} - screenSharingStatusChanged `, { JobId: props.job.id, screenshareStatus: screen_data['on'] })
			})

			api.on('incomingMessage', (info) => {
				console.log('JitsiContainer:::incomingMessage :', info)
				if (!notificationMsgShow) {
					audio.play() //Moved by karan inside if condition
					notificationMsgShow = true
					const msgFrom = props.userType === 'technician' ? 'customer' : 'technician'
					openNotificationWithIcon('info', 'Info', `New message from ${msgFrom}`)
					setTimeout(() => {
						notificationMsgShow = false
					}, 5000)
				}
			})

			// Listen for recording status changes from Jitsi
			api.addListener('recordingStatusChanged', (event) => {
				console.log('🎥 Recording status changed:', event)
				
				if (event.on === true) {
					console.log('� Recoording is ACTIVE - hiding banner')
					setIsRecordingActive(true)
					setShowRestartRecording(false)
				}

				if (event.on === false) {
					if (event.error === 'unexpected-request') {
						console.log('⚠️ Ignoring unexpected-request error')
						return
					}
					console.log('📢 Recording stopped - showing restart banner')
					setIsRecordingActive(false)
					setShowRestartRecording(true)
				}
			})
			// This will check if customer is already on call. If so then we will  don't call below function
			// const isAlreadyOnCall = window.localStorage.getItem(`${props?.job?.id}-in-call`)
			// if (((callDone && computerAudioEnabled) || customerCalledHimself) && isAlreadyOnCall != 'yes') {
			// 	// console.log('JitsiContainer:::customerCalledHimself')
			// 	window.localStorage.setItem('customerCallingHimSelf', false)
			// 	const finalPhoneNumber = props?.job?.customer?.phoneNumber
			// 	console.log('jitsiContainer::: callOnPhone Info:::', finalPhoneNumber)
			// 	api.invite([
			// 		{
			// 			allowed: true,
			// 			number: finalPhoneNumber,
			// 			originalEntry: `${props.job.customer.phoneNumber}`,
			// 			showCountryCodeReminder: false,
			// 			type: 'phone',
			// 		},
			// 	])
			// 	callDone = false
			// 	// Here we are setting in localstorage that one time call is already done. If he/she want another call there are buttons available
			// 	window.localStorage.setItem(`${props?.job?.id}-in-call`, 'yes')
			// }

			api.on('errorOccurred', async (data) => {
				console.log('error occured in jitsi setup :::::: ', data)
			})

			api.on('participantJoined', async (info) => {
				console.log('JitsiContainer::: participantJoinedInfo', info)
				let joinedParticipentArr = []
				try {
					const roomsInfo = await api.getRoomsInfo()
					console.log('JitsiContainer::: joinedParticipentArr', roomsInfo)
					joinedParticipentArr = roomsInfo?.rooms?.[0]?.participants || []
				} catch (error) {
					joinedParticipentArr = api.getParticipantsInfo() || []
					console.log('error while accessing participant', joinedParticipentArr)
				}
				// if somehow in above condition nothing works then we will again try to get getParticipantsInfo
				if (joinedParticipentArr.length >= 2) {
					console.log('while accessing participant  ', joinedParticipentArr)
					setAutomaticCallModal(false)
					/*if (props.userType === 'customer') {
						openNotificationWithIcon('success', 'Success', 'Your Geek has joined the meeting, no need to call them.')
					} else if (props.userType === 'technician') {
						openNotificationWithIcon('success', 'Success', 'Your Customer has joined the meeting, no need to call them.')
					}*/
				}
				if (joinedParticipentArr.length <= 0) {
					joinedParticipentArr = api.getParticipantsInfo()
					console.log('JitsiContainer::: participantInfo inside Safetycheck condition', joinedParticipentArr)
				}
				console.log('JitsiContainer::: joinedParticipentArr', joinedParticipentArr)
				const checkDesktopAvailab = await checkDesktopAvailability(joinedParticipentArr)
				const checkPhoneAvailab = await checkPhoneAvailability(joinedParticipentArr)
				console.log('JitsiContainer::: checkPhoneAvailability', { checkDesktopAvailab, checkPhoneAvailab })
				let response = await getJobInformation(props.job.id, props?.user?.id)
				let job = response.data
				console.log('JitsiContainer::: job', job)

				const meetingStarted = !job.meetingStarted
				const paidMeetingAlertTime = !job?.paid_meeting_alert_time

				if (meetingStarted && !job.schedule_accepted) {
					props.setRequiredParticipantJoined(true)
					if (paidMeetingAlertTime) {
						updateJob(props.job.id, {
							dataToUpdate: { paid_meeting_alert_time: new Date() },
							cuId: props?.user?.id,
						})
					}
				}
				let participants = await getParticipantDetails(api, props.userType)
				console.log('participants ::: :::: in meeting', participants)

				if (meetingStarted && job.schedule_accepted && (participants.length >= 2 || job.schedule_five_min_popup)) {
					props.setRequiredParticipantJoined(true)
					if (paidMeetingAlertTime) {
						const dataToUpdate = {
							paid_meeting_alert_time: new Date(),
							schedule_five_min_popup: true,
						}
						updateJob(props.job.id, {
							dataToUpdate,
							cuId: props?.user?.id,
						})
					}
				}

				let lifeCycleTag = ''
				if (props.userType === 'technician') {
					lifeCycleTag = JobTags.TECHNICIAN_JITSI_START
				} else {
					lifeCycleTag = JobTags.CUSTOMER_JITSI_START
				}
				if (props.job.is_transferred && props.job.is_transferred == true) {
					if (props.userType === 'technician') {
						lifeCycleTag = JobTags.TECHNICIAN_JITSI_START_AFTER_TRANSFER
					} else {
						lifeCycleTag = JobTags.CUSTOMER_JITSI_START_AFTER_TRANSFER
					}
				}
				await JobCycleApi.create(lifeCycleTag, props.job.id)
				//mixpanel code
				mixpanel.identify(props.user.email)
				mixpanel.track(`${props.userType} - Joined `, { JobId: props.job.id })
				//mixpanel code

				// Track Step 10: Meeting Joined - customer perspective
				if (props.userType === 'customer') {
					try {
						const userAgent = navigator.userAgent
						const deviceType = /Mobile|Android|iPhone/i.test(userAgent) ? 'mobile' : 'desktop'

						// Use the funnel manager to track Step 10
						jobCreationBaseFunnelManager.trackMeetingJoined({
							user: props.user,
							userId: props.user.id,
							jobId: props.job.id,
							technicianId: props.job.technician?.id,
							meetingId: props.job.id,
							meetingPlatform: 'jitsi',
							deviceType,
						})

						console.log('📊 Step 10: Meeting Joined tracked via funnel manager')
					} catch (error) {
						console.error('Error tracking meeting joined:', error)
					}
				}

				setShowLoader(false)
			})

			window.participantInfo = setTimeout(async function () {
				if (api) {
					let partispantsArr = []
					partispantsArr = await getParticipantDetails(api, props.userType)
					// if somehow in above condition nothing works then we will again try to get getParticipantsInfo
					if (partispantsArr.length <= 0) {
						partispantsArr = api.getParticipantsInfo()
						console.log('JitsiContainer::: participantInfo inside Safetycheck condition 2', partispantsArr)
					}

					if (partispantsArr.length > 0) {
						if (props.userType == 'technician') {
							displayNametype = '(t)'
						} else {
							displayNametype = '(c)'
						}
						const valueToFind = props.user.firstName.trim() + ' ' + props.user.lastName.trim() + ' ' + displayNametype + ' (me)'
						// console.log('valuess original', valueToFind)

						let hasParticipants = false
						let hasParticipantsNoSpace = false
						for (var i = 0; i < partispantsArr.length; i++) {
							if (partispantsArr[i] && partispantsArr[i]['formattedDisplayName']) {
								let participantInfo = partispantsArr[i]['formattedDisplayName'].trim()
								let participantInfoNoSpace = partispantsArr[i]['formattedDisplayName'].replace(/\s/g, '')
								let valueToFindNoSpace = valueToFind.replace(/\s/g, '')
								console.log(
									'JitsiContainer::: Participant Name with trim is .' +
									participantInfo +
									'. and valueToFind Name is .' +
									valueToFind.trim() +
									'.',
								)
								console.log(
									'JitsiContainer::: Participant Name with no space is .' +
									participantInfoNoSpace +
									'. and valueToFind Name with no space is .' +
									valueToFindNoSpace +
									'.',
								)
								if (participantInfo === valueToFind.trim()) {
									hasParticipants = true
								}
								if (participantInfoNoSpace === valueToFindNoSpace) {
									hasParticipantsNoSpace = true
								}
							} else {
								console.log('JitsiContainer::: Participant do not have formatted display name ', partispantsArr)
							}
						}
						console.log(
							'JitsiContainer::: Trying to find ' +
							valueToFind +
							' from partispantArr and the result of hasParticipants is ' +
							hasParticipants.toString() +
							' and the result of hasParticipantsNoSpace is ' +
							hasParticipantsNoSpace.toString(),
						)
						if (hasParticipants || hasParticipantsNoSpace) {
							console.log('JitsiContainer:::loader hide::: Jitsi loaded for ' + props.userType + ' - ' + valueToFind)
							setShowLoader(false)
						} else {
							// Don't retry if there are participants present (>=2), even if name matching fails
							if (partispantsArr.length >= 2) {
								console.log('JitsiContainer::: Participants present (' + partispantsArr.length + '), skipping retry despite name mismatch')
								setShowLoader(false)
							} else {
								console.log(
									'JitsiContainer:::retryJitsi::: Because ' + props.userType + ' - ' + valueToFind + ' not found in partispantArr',
								)
								retryJitsi()
							}
						}
					} else {
						console.log('JitsiContainer:::retryJitsi::: Because partispantArr is empty')
						retryJitsi()
					}
				} else {
					console.log('JitsiContainer:::retryJitsi::: Because jitsi api is not set.', api)
					retryJitsi()
				}
			}, 70000)
			// This function will start meeting recording
			startRecordingInterval = setInterval(() => {
				if (counter < 6) {
					startRecording()
					counter++
				}
			}, 10000)
		} catch (error) {
			console.log('JitsiContainer:::retryJitsi:::type 4', error)
			//mixpanel codetoggleShareScreen
			mixpanel.identify(props.user.email)
			mixpanel.track(`Error on ${props.userType} side`, { Error: error })
			//mixpanel code
			retryJitsi()
		}
	}

	/**
	 * Reload page
	 * @params = ''
	 * @response : Will reload the page if jitsi not worked and retry max upto 3 times only.
	 * @author : Karan,Jagroop
	 */
	const retryJitsi = () => {
		try {
			let meetingRetires = window.localStorage.getItem(`${props.job.id}-meeting-retires`)
			// console.log('JitsiContainer:::retryJitsi:::reloading page initiate:', meetingRetires)
			if (Number(meetingRetires) < 2) {
				//mixpanel code
				mixpanel.identify(props.user.email)
				mixpanel.track(`${props.userType} - Jitsi retry called`, { JobId: props.job.id })
				//mixpanel code
				if (props.job && props.job.id && props.job.status !== 'Completed') {
					console.log('JitsiContainer:::retryJitsi:::reloading page done:', meetingRetires)
					window.localStorage.setItem(`${props.job.id}-meeting-retires`, Number(meetingRetires) + 1)
					window.location.href = `/meeting/${props.userType}/${props.job.id}`
				}
			} else {
				console.log('JitsiContainer:::retryJitsi:::max retires reached:', meetingRetires)
				//mixpanel code
				mixpanel.identify(props.user.email)
				mixpanel.track(`${props.userType} - Jitsi max retires reached `, { JobId: props.job.id })
				//mixpanel code
			}
		} catch (error) {
			console.log('JitsiContainer:::retryJitsi:::error', error)
		}
	}

	/**
	 * Stop jitsi screenshare
	 * @params = ''
	 * @response : Will stop the screenshare of jitsi
	 * @author : Karan
	 */
	const stopShareScreen = () => {
		//mixpanel code
		mixpanel.identify(props.user.email)
		mixpanel.track(`${props.userType} - Stop screen share`, { JobId: props.job.id, showStopButton: showStopButton })
		//mixpanel code
		if (api != null && showStopButton === true) {
			console.log('JitsiContainer:::stopShareScreen', showStopButton)
			api.executeCommand('toggleShareScreen')
			setshowStopButton(false)
		}
	}

	const checkParticipantInfo = async (timer) => {
		let partisipantsArrInitial
		if (api != null) {
			partisipantsArrInitial = await getParticipantDetails(api, props.userType)
		}

		if (
			!props?.job.meetingStarted &&
			props?.job.schedule_accepted &&
			!props.requiredParticipantJoined &&
			(partisipantsArrInitial.length >= 2 || props.job.schedule_five_min_popup)
		) {
			// console.log('JitsiContainer second')
			props.setRequiredParticipantJoined(true)
		}

		window.particintInfoCheckSetTimeOut = setTimeout(async () => {
			if (api != null) {
				let partisipantsArr = await getParticipantDetails(api, props.userType)
				console.log('JSS: JitsiContainer:::particintInfoCheckSetTimeOut', {
					participantAfterDisconnect: props.participantAfterDisconnect,
					partisipantsArr,
				})
				console.log('JSS: JitsiContainer:::particintInfoCheckSetTimeOut before', { partisipantsArrInitial })
				console.log('JSS: JitsiContainer:::particintInfoCheckSetTimeOut participant Count', {
					after: partisipantsArr.length,
					before: partisipantsArrInitial.length,
				})
				const participantsAfterLeft = partisipantsArrInitial.length
				const particiapantsListAfterTimeout = partisipantsArr.length
				const otherPartyStillPresent =
					props.userType === 'customer'
						? isTechnicianStillInMeeting(partisipantsArr, props.job)
						: isCustomerStillInMeeting(partisipantsArr, props.job)
				// If timer is not started then we show popup with content regarding :"connect to user"
				if (
					!props?.job?.meeting_start_time &&
					!otherPartyStillPresent &&
					!props.showMicPermissionModal
				) {
					setAutomaticCallModal(true)
					//console.log("JSS: i am in IF 1")
					const userType = props.userType == 'customer' ? 'technician' : 'customer'
					setDisconnectedUserType(userType)
					// openNotificationWithIcon('success', "You've been reconnected! Enjoy your meeting")
				}
				// If paid time already started then we will show different content : "reconnecting user"
				if (props?.job?.meeting_start_time && !otherPartyStillPresent && !props.showMicPermissionModal) {
					setAutomaticCallModal(true)
					//console.log("JSS: i am in IF 2")
					const userType = props.userType == 'customer' ? 'technician' : 'customer'
					setDisconnectedUserType(userType)
					// openNotificationWithIcon('success', "You've been reconnected! Enjoy your meeting")
					props.socket.emit('participant-left', { JobId: props.job.id, disconnected: true, userType: userType, showPopup: true })
				}
			}
		}, timer)
	}

	// const handleZohoSessionClick = (userType) => {

	// 	if (props.userType === 'customer') {
	// 		// sessionData.userType = userType;
	// 		setShowRemoteAccessModalZoho(false);
	// 		// socket.emit('zoho-session', sessionData);
	// 	}
	// 	if(props.userType === 'technician'){
	// 		setShowRemoteAccessModalZoho(false);
	// 		// socketData.userType = userType;
	// 		// socket.emit('technician-want-tojoin',socketData);
	// 	}
	// };

	//   const openModal = () => {
	// 	setShowRemoteAccessModalZoho(true);
	// 	setShowRemoteZohoLinkTechSide(true);
	//   };

	//   const closeModal = () => {
	// 	setShowRemoteAccessModalZoho(false);
	//   };
	/**
	 * Hide the inactivity banner
	 * @author : Assistant
	 */
	const hideBanner = () => {
		console.log('❌ Hiding inactivity banner')
		setShowRestartRecording(false)
	}

	/**
	 * Handle restart recording - with timer reset
	 * @author : Assistant
	 */
	const handleRestartRecording = () => {
		if (!api) return
		
		try {
			console.log('🔄 Attempting to restart recording...')
			
			// Attempt to start recording
			api.executeCommand('startRecording', { mode: 'file' })
			
			// Hide banner after command is sent
			// (will hide/show again based on actual status from listener)
			setShowRestartRecording(false)
			
			openNotificationWithIcon(
				'success',
				'Recording Restarted',
				'Recording has been restarted successfully.'
			)
			
		} catch (error) {
			console.error('❌ Error restarting recording:', error)
			// Keep banner visible on error
			setShowRestartRecording(true)
			openNotificationWithIcon(
				'error',
				'Recording Error',
				'Failed to restart recording. Please try again.'
			)
		}
	}

	/**
	 * Start jitsi recording
	 * @params = ''
	 * @response : Will start the jitsi recording copied form V1 of this project
	 * @author : Manibha
	 */
	const startRecording = () => {
		if (!IS_RECORDING_ENABLED) {
			console.log('JitsiContainer:::startRecording skipped - Recording is disabled via environment configuration.')
			return
		}
		window.startRecordingTimeOut = setTimeout(() => {
			if (api != null) {
				console.log('JitsiContainer:::startRecording')
				api.executeCommand('startRecording', {
					mode: 'file',
				})
			}
			// }, Number(props.internetConnectionStatus[props.userType]) > 8 ? 10000 : 13000)
		}, 10000)
	}

	return (
		<>
			{/* <Modal
				title="Remote Session Meeting"
				className="custom-modal-title-zoho"
				visible={showRemoteAccessModalZoho}
				onCancel={closeModal}

				footer={null}
				maskClosable={false}
				destroyOnClose={true}
				bodyStyle={{
					boxShadow: '-1px -1px 2px #FDFDFD, 2px 2px 6px #D2DBE2',
					background: '#FFFFFF',
				}}
			>
				<div className="mx-4">
					{meetingDetails && (
						<div className="modal-text mt-2">
							<strong>Meeting Code: {meetingDetails.Code}</strong>
							<FontAwesomeIcon
								icon={copySuccess ? faCheck : faCopy}
								onClick={handleCopyClick}

								style={{ cursor: 'pointer', marginLeft: '10px' }}
							/>
						</div>
					)}
					<div className="modal-text">Click below to start remote session: </div>
					<div className="modal-text">
						<a href={zohoUrl} target="_blank" rel="noopener noreferrer" onClick={() => handleZohoSessionClick(props.userType)}>
							<FontAwesomeIcon icon={faHandPointRight} className="hand-icon" />	Start Remote Session
						</a>
					</div>
				</div>
			</Modal> */}

			{!isMobile && oneapi && props.userType === 'customer' && props.job && (
				<SharingYourScreenModal
					job={props.job}
					setOpenShareScreenModal={setOpenShareScreenModal}
					openShareScreenModal={openShareScreenModal}
					jitsiApi={api}
				/>
			)}
			{props.showMicPermissionModal &&
				props.job &&
				api &&
				props.userType &&
				props.job.callStartType === 'ComputerAudio' &&
				!props.phoneStatusAvailability && (
					<MicPermissionModal
						showMicPermissionModal={props.showMicPermissionModal}
						setShowMicPermissionModal={props.setShowMicPermissionModal}
						job={props.job}
						jitsiApi={api}
						userType={props.userType}
					/>
				)}

			{openAutomaticCallModal && props.job && api && !props.jitsiSessionEnd && (
				<AutomaticCallConnectModal
					openAutomaticCallModal={openAutomaticCallModal}
					job={props.job}
					setAutomaticCallModal={setAutomaticCallModal}
					disconnectedUserType={disconnectedUserType}
					jitsiApi={api}
					userType={props?.userType}
				/>
			)}

			{props.showRemoteAccessModal && props.job && api && props.userType && (
				<AllowRemoteAccessModal
					showRemoteAccessModal={props.showRemoteAccessModal}
					setShowRemoteAccessModal={props.setShowRemoteAccessModal}
				/>
			)}

			<Col xs="12" className="jitsi-screen-outer text-center mt-4">
				{showLoader && (
					<div className="session_loading session_loading_preloader">
						<MeetingOnboarding
							user={props.user}
							userType={props.userType}
							connectionStatus={connectionStatus}
							job={props.job}
							setStartChat={props.setStartChat}
							micPermission={micPermission}
						/>
					</div>
				)}

				{props.jitsiSessionEnd && (
					<div className="no-meeting-loaded">
						<div className="meeting-area text-center">
							<h2 className="mb-3">Ending meeting, please wait.....</h2>
						</div>
					</div>
				)}
				{(props.requiredParticipantJoined || props.job?.meeting_pause || props.showWarningApproachingTheEstimatedTime) && oneapi && (
					<StartPaidTimerAlert
						userType={props?.userType}
						job={props.job}
						totalPaidJobs={props.totalPaidJobs}
						socket={props.socket}
						api={oneapi}
						user={props.user}
						setRequiredParticipantJoined={props.setRequiredParticipantJoined}
						showWarningApproachingTheEstimatedTime={props?.showWarningApproachingTheEstimatedTime}
						setShowWarningApproachingTheEstimatedTime={props.setShowWarningApproachingTheEstimatedTime}
					/>
				)}
				{console.log('🔍 JSX Render - showRestartRecording:', showRestartRecording, 'isRecordingActive:', isRecordingActive, 'meetingStarted:', props.job?.meetingStarted, 'jitsiFullyLoaded:', jitsiFullyLoaded)}
				{showRestartRecording && !isRecordingActive && props.job?.meetingStarted && jitsiFullyLoaded && (
					<div className="alert-message-join-header-meeting-style">
						<Alert key="danger" variant="danger" className="alert-message-join-meeting-style d-flex justify-content-center align-self-center">
							<div className="End-Assesment-mode">
								<div className="End-Assesment-mode-inner">
									{/* Recording Icon */}
									<div style={{
										width: '20px',
										height: '20px',
										backgroundColor: '#dc3545',
										borderRadius: '50%',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										marginRight: '8px',
										flexShrink: 0
									}}>
										<div style={{
											width: '8px',
											height: '8px',
											backgroundColor: 'white',
											borderRadius: '50%'
										}}></div>
									</div>
									<span>
										<b>Recording was stopped. </b>
										Restart?
									</span>
								</div>
								<div className="meeting-start-btn-style">
									<div className="end-ass-btn" onClick={handleRestartRecording}>
										<span className="end-ass-btn-inner">Start Recording</span>
									</div>
								</div>
							</div>
						</Alert>
					</div>
				)}
				{!props.jitsiSessionEnd && <div id={props.jitsiContainerId} style={{ position: 'relative' }} />}
			</Col>
		</>
	)
}

export default JitsiContainer
